import useRouter from './useRouter';

const useNavigate = () => {
  const { history } = useRouter();
  return link => history.push(link);
};

export default useNavigate;
